import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  DisasterService,
  PostDisasterStatusParam,
} from '../../services/disasterRiskManagement/DisasterRiskManagementService'
import { useAuth } from '../../context/login/components/organisms/Protected/UserLogin'
import type { AxiosResponse } from 'axios'
import type { PostDisasterStatusRes } from '../../data/types/DisasterRiskManagement'
import { useRegisterDisasterMutation } from './useRegisterDisasterMutation'

export function useRegisterDrillEarthQuakeTsunamiMutation(
  onSuccess?: (data: AxiosResponse<PostDisasterStatusRes, any>) => void
) {
  const { currentTenantId } = useAuth()
  const queryClient = useQueryClient()
  const registerDisaster = useRegisterDisasterMutation()

  return useMutation({
    mutationFn: async (body: PostDisasterStatusParam) =>
      await DisasterService.postTsunamiEarthQuake(currentTenantId),

    async onSuccess(data, variables) {
      await registerDisaster.mutateAsync({
        disaster_type: variables.disaster_type,
        practice_flag: variables.practice_flag,
        new_disaster: variables.new_disaster,
      })
      queryClient.invalidateQueries({
        queryKey: ['tsunami-and-earthquake', currentTenantId],
      })

      onSuccess?.(data)
    },
  })
}
